import { reducerWithInitialState } from "typescript-fsa-reducers";
import { Entity } from "../documentUpload/types";
import { editEntity, getEntity, resetEntity } from "./actions";

export type InitialEntityViewState = null;
export type LoadedEntityViewState = Entity;
export type EntityViewState = InitialEntityViewState | LoadedEntityViewState;

const initialState = null;

const entityViewReducer = reducerWithInitialState<EntityViewState>(initialState)
  .case(getEntity.async.started, (state, _) => null)
  .case(resetEntity, (state, _) => null)
  .case(editEntity.async.done, (_, { result }) => result)
  .case(getEntity.async.done, (_, { result }) => result);

export default entityViewReducer;



// WEBPACK FOOTER //
// ./src/entityView/reducer.ts